/**
 * The rii.link brand pink, for the places a CSS custom property cannot reach.
 *
 * `--brand` in `app/globals.css` is the source for anything styled in CSS, and
 * anything that *can* use it must. But WebGL shader uniforms, canvas and SVG
 * attributes, and inline gradient strings are handed real colour values at
 * runtime — `var(--brand)` means nothing to them — so they read these constants
 * instead of each inventing a literal of their own. Inventing them separately is
 * exactly how the project ended up shipping four different pinks.
 *
 * `BRAND_PINK` is the logo colour exactly: sampling
 * `website/public/logos/logo-light.png` returns one flat `#FA437F` across all
 * 90,659 opaque pixels, with no gradient and no second pink.
 *
 * White on this colour measures 3.40:1 — enough for WCAG AA large text (3.0),
 * short of body text (4.5). It is a mark colour: logo, icon, fill, accent.
 * Type and links use `--brand-text`, never this.
 *
 * `lib/brand.test.ts` reads the real stylesheet and asserts these stay equal to
 * the CSS tokens, so the two halves cannot drift apart silently.
 */

/** The logo colour, for runtime consumers that need a literal (WebGL, SVG). */
export const BRAND_PINK = '#fa437f';

/** The same colour as authored in `app/globals.css`, for token comparisons. */
export const BRAND_PINK_OKLCH = 'oklch(0.6658 0.2206 6.05)';
